/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetGipMetadataVersionsQueryResponse, AuditReportsGetGipMetadataVersionsQueryParams, AuditReportsGetGipMetadataVersions401, AuditReportsGetGipMetadataVersions403 } from "../models/AuditReportsGetGipMetadataVersions";

export function getAuditReportsGetGipMetadataVersionsUrl() {
  const res = { method: 'GET', url: `/audit-reports/v1/reports/gip/metadata/versions` as const }
  return res
}

/**
 * @summary Return GIP versions for stations in a range
 * {@link /audit-reports/v1/reports/gip/metadata/versions}
 */
export async function auditReportsGetGipMetadataVersions(params: AuditReportsGetGipMetadataVersionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetGipMetadataVersionsQueryResponse, ResponseErrorConfig<AuditReportsGetGipMetadataVersions401 | AuditReportsGetGipMetadataVersions403>, unknown>({ method : "GET", url : getAuditReportsGetGipMetadataVersionsUrl().url.toString(), params, ... requestConfig })
  return res.data
}